
import projectPin from '@/api/projectPin'
import * as types from '../mutation-types'

const state = {
  currentProjectPin: null
}

const getters = {
  currentProjectPin: (state) => {
    return state.currentProjectPin
  }
}

const actions = {
  updateProjectPin ({ commit }, { pinURL, projectID }) {
    return new Promise((resolve, reject) => {
      projectPin.updateProjectPin(pinURL, projectID).then((response) => {
        const projectPin = response.data.result.projectPin
        resolve(projectPin)
      }, (error) => {
        reject(error)
      })
    })
  },
  getProjectPin ({ commit }, { projectID }) {
    return new Promise((resolve, reject) => {
      projectPin.getProjectPin(projectID).then((response) => {
        const projectPin = response.data.result.projectPin
        resolve(projectPin)
      }, (error) => {
        reject(error)
      })
    })
  },
  collectProjectPin ({ commit }, projectID) {
    return new Promise((resolve, reject) => {
      projectPin.collectProjectPin(projectID).then((response) => {
        resolve(response.data.result.pin)
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.ADD_PROJECT_PIN] (state, params) {
    state.currentProjectPin = params.projectPin
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
